import React, { useState } from 'react';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import Heading from '../heading';
import Paragraph from '../paragraph';
import { APPEARANCES } from '../paragraph/constants';
import Mark from '../mark';
import InfoWithPopover from '../info-with-popover';
import HorizontalStack from '../horizontal-stack';

const ControlGroup = ({
  children = null,
  title = '',
  additionalInfo = '',
  additionalInfoAppearance = APPEARANCES.highEmphasis,
  description = '',
  descriptionHTML = '',
  required = false,
  popoverProps = undefined,
  fullheight = false,
}) => {
  const isTouchDevice = bowser.mobile || bowser.tablet;
  const [isVisible, setIsVisible] = useState(isTouchDevice);

  const handlers = {
    onMouseEnter: () => setIsVisible(true),
    onMouseLeave: () => setIsVisible(false),
  };

  return (
    <div
      className={classNames('ws-ui-control-group', {
        'ws-ui-control-group--fullheight': fullheight,
      })}
      {...handlers}
    >
      {title && (
        <div className="ws-ui-control-group__title">
          <HorizontalStack verticalAlign="center">
            <Heading type="heading-6">
              {title}
              {required && <Mark appearance="danger">&nbsp;*</Mark>}
            </Heading>
            {popoverProps && isVisible && (
              <InfoWithPopover
                {...popoverProps}
                title={popoverProps.title || ''}
                {...(isTouchDevice && { mode: 'popover' })}
              />
            )}
          </HorizontalStack>
          {additionalInfo && (
            <div className="ws-ui-control-group__additional-info">
              <Paragraph appearance={additionalInfoAppearance} isClipped>
                {additionalInfoAppearance === APPEARANCES.highEmphasis ? (
                  <strong>{additionalInfo}</strong>
                ) : (
                  additionalInfo
                )}
              </Paragraph>
            </div>
          )}
        </div>
      )}
      {(description || descriptionHTML) && (
        <div className="ws-ui-control-group__description">
          <Paragraph size="small" appearance="medium-emphasis">
            {descriptionHTML ? (
              <span
                // eslint-disable-next-line yola/react/no-danger
                dangerouslySetInnerHTML={{ __html: descriptionHTML }}
              />
            ) : (
              description
            )}
          </Paragraph>
        </div>
      )}
      {children}
    </div>
  );
};

export default ControlGroup;
